/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Dashboard_Detail_Credit_PoolInputs */



/**
* | output |
* | --- |
* | "Credit pool" |
*
* @param {Partner_Dashboard_Detail_Credit_PoolInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_dashboard_detail_credit_pool = /** @type {((inputs?: Partner_Dashboard_Detail_Credit_PoolInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Dashboard_Detail_Credit_PoolInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Guthaben-Pool")
	return /** @type {LocalizedString} */ ("Credit pool")
});